/**
 * Sorts games ascending by availableUntil (soonest expiry first).
 * Games with no availableUntil go last.
 * coming-soon games are always sorted last.
 */
export function sortByExpiry(games) {
  return [...games].sort((a, b) => {
    const aCS = a.type === 'coming-soon';
    const bCS = b.type === 'coming-soon';
    if (aCS && bCS) {
      // Both coming-soon: sort by start date (soonest first)
      if (!a.availableFrom && !b.availableFrom) return 0;
      if (!a.availableFrom) return 1;
      if (!b.availableFrom) return -1;
      return new Date(a.availableFrom) - new Date(b.availableFrom);
    }
    if (aCS) return 1;
    if (bCS) return -1;
    if (!a.availableUntil && !b.availableUntil) return 0;
    if (!a.availableUntil) return 1;
    if (!b.availableUntil) return -1;
    return new Date(a.availableUntil) - new Date(b.availableUntil);
  });
}

/** Sort options exposed to the UI */
export const SORT_OPTIONS = [
  { id: 'expiry',    label: 'Expiring Soonest' },
  { id: 'alpha',     label: 'A – Z' },
  { id: 'platform',  label: 'Platform' },
];

export function sortGames(games, sortId) {
  switch (sortId) {
    case 'alpha':
      return [...games].sort((a, b) => a.title.localeCompare(b.title));
    case 'platform':
      return [...games].sort((a, b) => a.platform.localeCompare(b.platform) || a.title.localeCompare(b.title));
    case 'expiry':
    default:
      return sortByExpiry(games);
  }
}
